import Banner from '../components/banner';
import Footer from '../components/shared/footer';
import CoinList from '../components/table';


const Home = () => {
    return (
        <div className="bg-[var(--bg-lighter)]">
            <Banner />
            <CoinList />
            <Footer />

        </div>
    )

}

export default Home;